import { render, staticRenderFns } from "./required-documents-dynamic-form.vue?vue&type=template&id=2b0a7ae7"
import script from "./required-documents-dynamic-form.vue?vue&type=script&lang=js"
export * from "./required-documents-dynamic-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports